/**
 * Safari 兼容性：requestIdleCallback polyfill
 * Safari 浏览器不支持 requestIdleCallback API，需要降级为 setTimeout
 */

export const safeRequestIdleCallback = (
  callback: () => void, 
  options?: { timeout?: number }
): number => {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    return window.requestIdleCallback(callback, options);
  } else {
    // Safari 降级方案：使用 setTimeout
    const timeout = options?.timeout || 5000;
    return setTimeout(callback, Math.min(timeout, 3000)) as any;
  }
};

export const safeCancelIdleCallback = (id: number): void => {
  if (typeof window !== 'undefined' && 'cancelIdleCallback' in window) {
    window.cancelIdleCallback(id);
  } else {
    clearTimeout(id as any);
  }
};
